const bundle = {
  close: () => 'Fermer',
  error: () => 'Erreur',
  warn: () => 'Avertissement',
  info: () => 'Infos',
  confirmation: () => 'Confirmation',
  progressIndeterminate: () => 'En cours',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Entre ' + p['FROM_SECTION'] + ' et ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Aucune section correspondante trouvée.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Appuyez sur Entrée pour sélectionner la valeur.',
  indexer_touchInstructionText: () =>
    'Touchez deux fois et maintenez pour passer en mode geste, puis glissez vers le haut ou le bas pour ajuster la valeur.',
  inputPassword_show: () => 'Afficher le mot passe',
  inputPassword_hide: () => 'Masquer le mot de passe',
  inputPassword_hidden: () => 'Mot de passe masqué',
  formControl_clear: () => 'Effacer',
  formControl_loading: () => 'Chargement',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Longueur maximale ' + p['MAX_LENGTH'] + ' dépassée.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' caractères restants.',
  select_noMatchesFound: () => "Aucune correspondance n'a été trouvée.",
  select_oneMatchFound: () => 'Une correspondance a été trouvée',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' correspondances trouvées',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' correspondances ou plus trouvées',
  selectMultiple_showSelectedValues: () => 'Afficher les valeurs sélectionnées uniquement.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' valeurs sélectionnées.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selector_selected: () => 'Case cochée',
  selector_unselected: () => 'Case non cochée',
  userAssistance_learnMore: () => 'En savoir plus',
  userAssistance_required: () => 'Obligatoire',
  filePicker_singleFileUploadError: () => 'Charger un fichier à la fois',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Vous ne pouvez pas charger des fichier de type ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Vous ne pouvez pas charger des fichiers ayant les types suivants : ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'inconnu',
  filePicker_dropzonePrimaryText: () => 'Glisser-déposer',
  filePicker_dropzoneSecondaryText: () => 'Sélectionner un fichier ou déposer un fichier ici',
  filePicker_dropzoneSecondaryTextMultiple: () =>
    'Sélectionner des fichiers ou déposer des fichiers ici',
  filePicker_addFiles: () => 'Ajouter des fichiers',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Augmenter',
  inputNumber_decrease: () => 'Réduire',
  inputNumber_converterParseError: () => 'Enter a number.',
  noData_message: () => 'Aucun élément à afficher',
  message_navigationFromMessagesRegion: () =>
    'Entrée dans la région des messages. Appuyez sur F6 pour retourner au dernier élément ciblé.',
  message_navigationToMessagesRegion: () =>
    'La région des messages contient des nouveaux messages. Appuyez sur F6 pour accéder à la région du message le plus récent.',
  messageToast_allMessagesClosed: () => 'Tous les avis Toast sont fermés.'
};
export default bundle;
